import React, { Component } from 'react'
import Layout from './../components/layout'

function withLayout(ComposedComponent) {
  return class WithLayout extends Component {
    render = () => (
      <Layout { ...this.props }>
        <ComposedComponent { ...this.props } />
      </Layout>
    )
  }
}

export default withLayout



// WEBPACK FOOTER //
// ./src/helpers/withLayout.js